import React from 'react';
import ErrorIcon from '@mui/icons-material/Error';
import { Box, Typography } from '@mui/material';

interface FormErrorProps {
  message: string;
  details?: string;
}

export const FormError: React.FC<FormErrorProps> = ({ message, details }) => {
  return (
    <Box color="error.main" my={3} display="flex" alignItems="center">
      <ErrorIcon fontSize="small" sx={{ mr: 1 }} />
      <Typography variant="body2" component="div">
        {details || message}
      </Typography>
    </Box>
  );
};
